import React, { PropsWithChildren } from 'react';
import { twJoin } from 'tailwind-merge';

export const typoTypeData = {
  default: 'text-b16r',

  // heading
  h36b: 'text-h36b',
  h30b: 'text-h30b',
  h26sb: 'text-h26sb',
  h24sb: 'text-h24sb',
  h20sb: 'text-h20sb',
  h16b: 'text-h16b',
  h16sb: 'text-h16sb',

  // body
  b16b: 'text-b16b',

  b18sb: 'text-b18sb',
  b16sb: 'text-b16sb',
  b14sb: 'text-b14sb',
  b13sb: 'text-b13sb',
  b12sb: 'text-b12sb',

  b18m: 'text-b18m',
  b16m: 'text-b16m',
  b14m: 'text-b14m',
  b13m: 'text-b13m',
  b12m: 'text-b12m',

  b18r: 'text-b18r',
  b16r: 'text-b16r',
  b14r: 'text-b14r',
  b13r: 'text-b13r',
  b12r: 'text-b12r',
  b11r: 'text-b11r',

  list16r: 'text-list16r',
};

export const typoColorData = {
  default: 'text-gray9',

  // Gray
  gray0: 'text-gray0',
  gray1: 'text-gray1',
  gray2: 'text-gray2',
  gray3: 'text-gray3',
  gray4: 'text-gray4',
  gray5: 'text-gray5',
  gray6: 'text-gray6',
  gray7: 'text-gray7',
  gray8: 'text-gray8',
  gray9: 'text-gray9',

  // Blue
  blue0: 'text-blue0',
  blue1: 'text-blue1',
  blue2: 'text-blue2',
  blue3: 'text-blue3',
  blue4: 'text-blue4',
  blue5: 'text-blue5',
  blue6: 'text-blue6',
  blue7: 'text-blue7',
  blue8: 'text-blue8',
  blue9: 'text-blue9',

  // Red
  red0: 'text-red0',
  red1: 'text-red1',
  red2: 'text-red2',
  red3: 'text-red3',
  red4: 'text-red4',
  red5: 'text-red5',
  red6: 'text-red6',

  // Yellow
  yellow0: 'text-yellow0',
  yellow1: 'text-yellow1',
  yellow2: 'text-yellow2',
  yellow3: 'text-yellow3',
  yellow4: 'text-yellow4',
  yellow5: 'text-yellow5',
  yellow6: 'text-yellow6',

  // Green
  green0: 'text-green0',
  green1: 'text-green1',
  green2: 'text-green2',
  green3: 'text-green3',
  green4: 'text-green4',
  green5: 'text-green5',
  green6: 'text-green6',

  // Pink
  pink0: 'text-pink0',
  pink1: 'text-pink1',
  pink2: 'text-pink2',
  pink3: 'text-pink3',
  pink4: 'text-pink4',
  pink5: 'text-pink5',
  pink6: 'text-pink6',

  white: 'text-white',
};

export interface TypoProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLSpanElement>,
    HTMLSpanElement
  > {
  typoType?: keyof typeof typoTypeData;
  typoColor?: keyof typeof typoColorData;
}

const Typo = ({
  typoColor = 'gray9',
  typoType = 'b14r',
  className,
  ...props
}: PropsWithChildren<TypoProps>) => {
  const getTypoTypoToFontFamily = () => {
    if (
      typoType === 'b18r' ||
      typoType === 'b16r' ||
      typoType === 'b14r' ||
      typoType === 'b13r' ||
      typoType === 'b12r' ||
      typoType === 'b11r' ||
      typoType === 'list16r'
    ) {
      return 'font-pretendardRegular';
    }

    if (
      typoType === 'b18m' ||
      typoType === 'b16m' ||
      typoType === 'b14m' ||
      typoType === 'b13m' ||
      typoType === 'b12m'
    ) {
      return 'font-pretendardMedium';
    }

    if (
      typoType === 'h26sb' ||
      typoType === 'h24sb' ||
      typoType === 'h20sb' ||
      typoType === 'h16sb' ||
      typoType === 'b18sb' ||
      typoType === 'b16sb' ||
      typoType === 'b14sb' ||
      typoType === 'b13sb' ||
      typoType === 'b12sb'
    ) {
      return 'font-pretendardSemiBold';
    }

    if (typoType === 'h36b' || typoType === 'h30b' || typoType === 'h16b') {
      return 'font-pretendardBold';
    }
  };

  return (
    <span
      className={twJoin(
        'overflow-hidden text-ellipsis',
        getTypoTypoToFontFamily(),
        typoTypeData[typoType],
        typoColorData[typoColor],
        className,
      )}
      {...props}
    />
  );
};

export default Typo;
